import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, Inject, inject, DestroyRef } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { WorkplaceGroupService } from '../../../../services';
import { ToastAlertService } from '@core/services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { InputComponent } from '@shared/components/input/input.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-work-place-group-modal',
  templateUrl: './work-place-group-modal.component.html',
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogContent,
    InputComponent,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
  ],
})
export class WorkPlaceGroupModalComponent {
  private formBuilder = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<WorkPlaceGroupModalComponent>);
  private workPlaceService = inject(WorkplaceGroupService);
  private alertService = inject(ToastAlertService);
  public operation = '';
  public workPlaceGroupForm!: FormGroup;
  private destroyRef = inject(DestroyRef);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    console.log(this.data.action);
    this.builderForm();
  }

  private builderForm() {
    if (this.data.action?.id) {
      this.operation = 'Modificar';
      this.workPlaceGroupForm = this.formBuilder.group({
        id: [this.data.action?.id],
        name: [
          this.data.action?.name,
          [Validators.required, Validators.maxLength(50)],
        ],
        description: [
          this.data.action?.description,
          [Validators.required, Validators.maxLength(256)],
        ],
      });
    } else {
      this.operation = 'Crear';
      this.workPlaceGroupForm = this.formBuilder.group({
        id: ['0'],
        name: ['', [Validators.required, Validators.maxLength(50)]],
        description: ['', [Validators.required, Validators.maxLength(256)]],
      });
    }
  }

  get id_action() {
    return this.workPlaceGroupForm.get('id');
  }

  submit() {
    if (this.id_action?.value == 0) {
      this.store();
    } else {
      this.update();
    }
  }

  private store() {
    if (this.workPlaceGroupForm.valid) {
      console.log('data', this.data);
      this.workPlaceService
        .storeWorkplace(
          this.workPlaceGroupForm.value,
          parseInt(this.data.businessId)
        )
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000) {
              this.alertService.sucess('Grupo de puestos de trabajo creado');
              this.dialogRef.close(true);
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }

  private update() {
    if (this.workPlaceGroupForm.value) {
      this.workPlaceService
        .updateWorkplace(
          this.workPlaceGroupForm.value,
          this.id_action?.value,
          this.data.action.business_id
        )
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000) {
              this.alertService.sucess(
                'Grupo de puestos de trabajo modificado'
              );
              this.dialogRef.close(true);
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }

  clearForm() {
    this.builderForm();
  }
}
